import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

import {
    trigger,
    state,
    style,
    transition,
    animate,
} from '@angular/animations';
import { DashboardTitleComponent } from '../dashboard-title/dashboard-title.component';

@Component({
    selector: 'app-collapsible-section',
    templateUrl: './collapsible-section.component.html',
    styleUrls: ['./collapsible-section.component.scss'],
    imports: [DashboardTitleComponent],
    animations: [
        trigger('slideDown', [
            state(
                'collapsed',
                style({
                    height: '0',
                    opacity: '0',
                }),
            ),
            state(
                'expanded',
                style({
                    height: '*',
                    opacity: '1',
                }),
            ),
            transition('collapsed <=> expanded', [
                animate('300ms ease-in-out'),
            ]),
        ]),
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        '[class.expanded]': 'expanded',
        '[class.collapsed]': '!expanded',
        '[class]': 'sectionWidth',
        '[attr.title]': 'null',
    },
})
export class CollapsibleSectionComponent {
    @Input() title: string = '';
    @Input() tooltipText: string = '';
    @Input() subtitle: string = '';
    @Input() expanded: boolean = true;
    @Input() showExpandButton: boolean = true;
    @Input() showButtonText: boolean = false;
    @Input() sectionWidth: string = '';

    toggleExpanded(): void {
        this.expanded = !this.expanded;
    }
}
